module.exports = __webpack_public_path__ + "assets/user-profile-bg.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user-profile-bg.jpg
// module id = 1675
// module chunks = 7